export default "__VITE_ASSET__gtmVqZqZ__"